var _g, _path, _path2, _g2, _g3, _path3, _path4, _path5, _g4, _path6, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1059_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.584 10.5524V6.3809C14.584 4.3034 16.2392 2.6189 18.2815 2.6189C20.3237 2.6189 21.979 4.3034 21.979 6.3809V7.1954",
    stroke: "#C2C2C6",
    strokeWidth: 2.0625,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.584 10.5524V6.3809C14.584 4.3034 16.2392 2.6189 18.2815 2.6189C20.3237 2.6189 21.979 4.3034 21.979 6.3809V7.1954",
    stroke: "url(#paint0_radial_1059_8)",
    strokeWidth: 2.0625,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.584 10.5524V6.3809C14.584 4.3034 16.2392 2.6189 18.2815 2.6189C20.3237 2.6189 21.979 4.3034 21.979 6.3809V7.1954",
    stroke: "url(#paint1_radial_1059_8)",
    strokeWidth: 2.0625,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1059_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9126 10.3185V6.14626C14.9126 4.06876 16.5678 2.38501 18.6101 2.38501C20.6516 2.38501 22.3076 4.06876 22.3076 6.14626V6.96076",
    stroke: "url(#paint2_radial_1059_8)",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9126 10.3185V6.14626C14.9126 4.06876 16.5678 2.38501 18.6101 2.38501C20.6516 2.38501 22.3076 4.06876 22.3076 6.14626V6.96076",
    stroke: "url(#paint3_radial_1059_8)",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_iiii_1059_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0321 8.29126H4.07861C2.83597 8.29126 1.82861 9.29862 1.82861 10.5413V20.1743C1.82861 21.4169 2.83597 22.4243 4.07861 22.4243H16.0321C17.2748 22.4243 18.2821 21.4169 18.2821 20.1743V10.5413C18.2821 9.29862 17.2748 8.29126 16.0321 8.29126Z",
    fill: "url(#paint4_linear_1059_8)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0321 8.29126H4.07861C2.83597 8.29126 1.82861 9.29862 1.82861 10.5413V20.1743C1.82861 21.4169 2.83597 22.4243 4.07861 22.4243H16.0321C17.2748 22.4243 18.2821 21.4169 18.2821 20.1743V10.5413C18.2821 9.29862 17.2748 8.29126 16.0321 8.29126Z",
    fill: "url(#paint5_radial_1059_8)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0321 8.29126H4.07861C2.83597 8.29126 1.82861 9.29862 1.82861 10.5413V20.1743C1.82861 21.4169 2.83597 22.4243 4.07861 22.4243H16.0321C17.2748 22.4243 18.2821 21.4169 18.2821 20.1743V10.5413C18.2821 9.29862 17.2748 8.29126 16.0321 8.29126Z",
    fill: "url(#paint6_linear_1059_8)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0321 8.29126H4.07861C2.83597 8.29126 1.82861 9.29862 1.82861 10.5413V20.1743C1.82861 21.4169 2.83597 22.4243 4.07861 22.4243H16.0321C17.2748 22.4243 18.2821 21.4169 18.2821 20.1743V10.5413C18.2821 9.29862 17.2748 8.29126 16.0321 8.29126Z",
    fill: "url(#paint7_radial_1059_8)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1059_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.104 15.294C11.4598 15.0648 11.7317 14.7262 11.8787 14.3293C12.0257 13.9324 12.0399 13.4984 11.9192 13.0927C11.7984 12.687 11.5493 12.3314 11.2093 12.0794C10.8692 11.8274 10.4565 11.6925 10.0332 11.6951C9.60993 11.6977 9.19892 11.8375 8.86193 12.0937C8.52494 12.3498 8.28017 12.7084 8.1644 13.1155C8.04863 13.5227 8.06811 13.9564 8.21991 14.3515C8.37172 14.7467 8.64765 15.0819 9.00625 15.3068V17.7773C9.00625 18.0554 9.11675 18.3222 9.31346 18.5189C9.51016 18.7156 9.77694 18.8261 10.0551 18.8261C10.3333 18.8261 10.6001 18.7156 10.7968 18.5189C10.9935 18.3222 11.104 18.0554 11.104 17.7773V15.294Z",
    stroke: "url(#paint8_linear_1059_8)",
    strokeWidth: 1.3125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.104 15.294C11.4598 15.0648 11.7317 14.7262 11.8787 14.3293C12.0257 13.9324 12.0399 13.4984 11.9192 13.0927C11.7984 12.687 11.5493 12.3314 11.2093 12.0794C10.8692 11.8274 10.4565 11.6925 10.0332 11.6951C9.60993 11.6977 9.19892 11.8375 8.86193 12.0937C8.52494 12.3498 8.28017 12.7084 8.1644 13.1155C8.04863 13.5227 8.06811 13.9564 8.21991 14.3515C8.37172 14.7467 8.64765 15.0819 9.00625 15.3068V17.7773C9.00625 18.0554 9.11675 18.3222 9.31346 18.5189C9.51016 18.7156 9.77694 18.8261 10.0551 18.8261C10.3333 18.8261 10.6001 18.7156 10.7968 18.5189C10.9935 18.3222 11.104 18.0554 11.104 17.7773V15.294Z",
    stroke: "url(#paint9_linear_1059_8)",
    strokeWidth: 1.3125
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.104 15.294C11.4598 15.0648 11.7317 14.7262 11.8787 14.3293C12.0257 13.9324 12.0399 13.4984 11.9192 13.0927C11.7984 12.687 11.5493 12.3314 11.2093 12.0794C10.8692 11.8274 10.4565 11.6925 10.0332 11.6951C9.60993 11.6977 9.19892 11.8375 8.86193 12.0937C8.52494 12.3498 8.28017 12.7084 8.1644 13.1155C8.04863 13.5227 8.06811 13.9564 8.21991 14.3515C8.37172 14.7467 8.64765 15.0819 9.00625 15.3068V17.7773C9.00625 18.0554 9.11675 18.3222 9.31346 18.5189C9.51016 18.7156 9.77694 18.8261 10.0551 18.8261C10.3333 18.8261 10.6001 18.7156 10.7968 18.5189C10.9935 18.3222 11.104 18.0554 11.104 17.7773V15.294Z",
    fill: "url(#paint10_radial_1059_8)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1059_8",
    x: 13.5527,
    y: 1.58765,
    width: 10.2075,
    height: 9.99609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.556863 0 0 0 0 0.576471 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1059_8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1059_8",
    x: 13.9751,
    y: 1.44751,
    width: 9.27002,
    height: 9.80859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.28125,
    result: "effect1_foregroundBlur_1059_8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_iiii_1059_8",
    x: 1.26611,
    y: 7.72876,
    width: 17.5786,
    height: 15.2581,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.5625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.28125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.898039 0 0 0 0 0.364706 0 0 0 0 0.423529 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1059_8"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.28125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.772549 0 0 0 0 0.364706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1059_8",
    result: "effect2_innerShadow_1059_8"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.28125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.843137 0 0 0 0 0.266667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1059_8",
    result: "effect3_innerShadow_1059_8"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.28125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.729412 0 0 0 0 0.478431 0 0 0 0 0.207843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_1059_8",
    result: "effect4_innerShadow_1059_8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1059_8",
    x: 7.05859,
    y: 10.6638,
    width: 5.97314,
    height: 9.1936,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875,
    result: "effect1_foregroundBlur_1059_8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1059_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.3985 6.1169) rotate(-91.6531) scale(4.06219 4.35925)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#AB83C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBBBDC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1059_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.979 8.5544) rotate(-90) scale(1.66406 6.60929)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#B57FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B57FD6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1059_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5273 3.40351) rotate(136.625) scale(3.79025 5.20766)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#EDECF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECF3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1059_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.04 12.6096) rotate(-80.102) scale(7.08991 5.11716)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDECF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECF3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1059_8",
    x1: 5.67236,
    y1: 10.5878,
    x2: 10.8751,
    y2: 22.4235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7864E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1059_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8599 22.4235) rotate(-132.274) scale(2.43896 5.68198)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8650",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1059_8",
    x1: 10.0546,
    y1: 8.05651,
    x2: 10.0546,
    y2: 9.18151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3D04E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1059_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0466 8.29121) rotate(126.254) scale(1.74385 3.93878)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF760",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1059_8",
    x1: 12.3985,
    y1: 16.26,
    x2: 9.49225,
    y2: 16.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#D98A40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D98A40",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1059_8",
    x1: 7.711,
    y1: 15.5565,
    x2: 9.75025,
    y2: 15.5565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD63",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1059_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.08932 13.9632) rotate(34.061) scale(4.26841 5.87039)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.217,
    stopColor: "#564F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#473154"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnlock);
export default __webpack_public_path__ + "static/media/ic_unlock.90a75979feda8fac0c3050ad6a40249c.svg";
export { ForwardRef as ReactComponent };